import React, { ComponentProps, ForwardedRef } from 'react';
import { Link } from 'react-router-dom';

export type AbstractButtonProps = ComponentProps<'a'> &
  ComponentProps<'button'> & { enforceLink?: boolean };

export const AbstractButton = React.forwardRef<
  HTMLButtonElement | HTMLAnchorElement,
  AbstractButtonProps
>(({ href, enforceLink = false, type = 'button', ...props }, ref) => {
  if (href) {
    return href.startsWith('/') || !enforceLink ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      <Link ref={ref as any} {...props} to={href} />
    ) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      <a ref={ref as any} {...props} href={href} rel="noopener noreferrer" />
    );
  }

  return (
    <button
      ref={ref as ForwardedRef<HTMLButtonElement>}
      // eslint-disable-next-line react/button-has-type
      type={type}
      {...props}
    />
  );
});
